import { getColor } from '../../../../theme-tools';
import { asMultiStyleConfig } from '../../../../utils/theme';
import { getDefaults } from './input';
var parts = ['root', 'modalContainer', 'modalBody', 'modalFooter'];
var baseStyle = props => ({
  root: (() => {
    var {
      theme
    } = props;
    var {
      focusBoxShadowColor
    } = getDefaults(props);
    return {
      '& .tqc-date-picker__calendar-icon': {
        color: 'black'
      },
      '& .tqc-date-picker__calendar': {
        boxShadow: 'none',
        borderRadius: 'none',
        border: "1px solid ".concat(getColor(theme, 'grey.650')),
        '&--mobile': {
          width: '100%',
          border: 'none'
        }
      },
      '& .tqc-date-picker__header': {
        bg: 'grey.650'
      },
      '& .react-datepicker__month': {
        mx: 4,
        mt: 0,
        mb: 3
      },
      '& .react-datepicker__day-names': {
        mx: 4,
        mt: 3
      },
      '& .react-datepicker__day-name': {
        fontSize: 'md',
        color: 'grey.980',
        fontWeight: 'bold',
        letterSpacing: 'tighter',
        textTransform: 'none'
      },
      '& .react-datepicker__day': {
        fontSize: 'md',
        fontWeight: 'normal',
        color: 'grey.980',
        borderRadius: 0,
        _hover: {
          bg: 'blue.600',
          color: 'white'
        },
        _focus: {
          boxShadow: 'none',
          border: "2px solid ".concat(getColor(theme, 'grey.950')),
          bg: getColor(theme, focusBoxShadowColor),
          fontWeight: 'semibold',
          color: 'black'
        },
        _pressed: {
          boxShadow: 'none',
          border: "2px solid ".concat(getColor(theme, 'grey.950')),
          bg: getColor(theme, focusBoxShadowColor),
          color: 'black',
          fontWeight: 'semibold'
        },
        '&--selected': {
          boxShadow: 'none',
          bg: getColor(theme, focusBoxShadowColor),
          color: 'black',
          borderRadius: 0,
          fontWeight: 'semibold',
          border: "2px solid ".concat(getColor(theme, 'grey.950')),
          _focus: {
            boxShadow: "0 0 0 2px ".concat(getColor(theme, focusBoxShadowColor))
          },
          _hover: {
            boxShadow: 'none',
            bg: getColor(theme, focusBoxShadowColor),
            color: 'black'
          }
        },
        '&--disabled': {
          color: 'grey.500'
        },
        '&--today': {
          border: "2px solid ".concat(getColor(theme, 'grey.950')),
          borderRadius: 0
        },
        '&--keyboard-selected': {
          bg: 'transparent',
          color: 'black',
          _focus: {
            border: "2px solid ".concat(getColor(theme, focusBoxShadowColor)),
            boxShadow: 'none'
          }
        }
      },
      '& .react-datepicker__day--outside-month': {
        color: 'grey.980',
        '&.react-datepicker__day--disabled': {
          color: 'grey.500'
        },
        '&.react-datepicker__day--selected': {
          color: 'grey.980'
        }
      },
      '& .tqc-date-picker__nav-button': {
        color: 'white',
        p: 3,
        fontSize: '2rem',
        height: '2.75rem',
        borderRadius: 0,
        bg: 'transparent',
        '&--next': {
          pl: '0.125rem',
          pr: '0.375rem'
        },
        '&--prev': {
          pl: '0.375rem',
          pr: '0.125rem'
        },
        _hover: {
          bg: 'blue.600',
          color: 'white'
        },
        _focus: {
          boxShadow: 'none',
          bg: getColor(theme, focusBoxShadowColor),
          color: 'black'
        },
        _pressed: {
          boxShadow: 'none',
          bg: getColor(theme, focusBoxShadowColor),
          color: 'black'
        },
        _active: {
          color: 'blue.1140'
        },
        _disabled: {
          cursor: 'not-allowed',
          color: 'grey.500',
          bg: 'transparent',
          opacity: 0.7
        }
      }
    };
  })(),
  modalContainer: {},
  modalBody: {},
  modalFooter: {
    alignItems: 'flex-start',
    '& > button:first-of-type': {
      mb: 6
    }
  }
});
export default asMultiStyleConfig({
  parts,
  baseStyle
});